/* eslint-disable */
import React, { Suspense } from 'react'
import { useState } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { init as initApm } from '@elastic/apm-rum'
import { useLDAAuth, LDAAuthProvider } from './components/authorization/LDAAuthProvider.js'
import { useAuth } from "react-oidc-context";


import { useIdleTimer } from 'react-idle-timer'
import {
  Button,
  ChakraProvider,
  Heading,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react'

import './scss/style.scss'
const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

initApm({
  serviceName: process.env.REACT_APP_OS_APM_SERVICE_NAME,
  serverUrl: process.env.REACT_APP_OS_APM_SERVICE_URL,
  serviceVersion: process.env.REACT_APP_OS_APM_SERVICE_VERSION,
  environment: process.env.REACT_APP_OS_APM_SERVICE_ENVIRONMENT,
})

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))
const LoginPage = React.lazy(() => import('./pages/login/login'))
const WaitLogin = React.lazy(() => import('./pages/login/wait'))

const ProtectedPage = () => {

    const auth = useAuth();

    const isAuthenticated = (auth.isAuthenticated && (auth.user.profile.iss === "https://online.otto-schmidt.de" || auth.user.profile.groups.indexOf("f403504a-aca9-4402-a3d1-edcfc0c5e615") != -1));

    if (auth && !isAuthenticated) {
      return <p>Loading ...</p>;
    }
    else if (auth && isAuthenticated) {
      return (
        <div>
          <BrowserRouter>
            <Suspense fallback={loading}>
                <Routes>
                  <Route path="*" name="Home" element={<DefaultLayout />} />
                </Routes>
            </Suspense>
          </BrowserRouter>

        </div>
      );
    }
};

const App = (props) => {
    return (
      <LDAAuthProvider>
        <LoginPage />
        <ProtectedPage />
      </LDAAuthProvider>
    );
}

export default App
